const SW_URL = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        registration.onupdatefound = () => {
          const worker = registration.installing;
          if (!worker) {
            return;
          }

          worker.onstatechange = () => {
            if (worker.state !== 'installed') {
              return;
            }

            if (navigator.serviceWorker.controller) {
              console.info('A new version is available. Refresh to update.');
              return;
            }

            console.info('App is ready for offline use.');
          };
        };
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
